import { render, staticRenderFns } from "./H5Menu.vue?vue&type=template&id=74b2b4b9&scoped=true&"
import script from "./H5Menu.vue?vue&type=script&lang=ts&"
export * from "./H5Menu.vue?vue&type=script&lang=ts&"
import style0 from "./H5Menu.vue?vue&type=style&index=0&id=74b2b4b9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74b2b4b9",
  null
  
)

export default component.exports